<template>
  <div class="summary-section" :data-aos="isInternalView?'':'fade-up'" data-aos-once="true">
    <v-container :class="isInternalView ? 'internal-view-container' : ''">
      <v-expansion-panels v-model="panel" dark accordion>
        <v-expansion-panel expand>
          <v-expansion-panel-header>
            <v-app-bar
                dark
                color="#212121"
                >
                <v-toolbar-title style="text-align:center;">
                  Campaign Summary
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                  @click.native.stop
                  @click="cancelEdit('summary')"
                  v-if="editCampaignSummary"
                  class="mr-1 secondary--text surface"
                >
                  Cancel
                </v-btn>

                <v-btn
                  @click.native.stop
                  @click="saveEdit"
                  color="primary"
                  class="secondary--text"
                  v-if="editCampaignSummary && !uploadSubmitting"
                >
                  <v-icon>mdi-done</v-icon> Save
                </v-btn>
                <v-btn
                  @click.native.stop
                  color="warning"
                  dark
                  v-if="editCampaignSummary && uploadSubmitting"
                  :disabled="true"
                >
                  <v-progress-circular indeterminate :size="20"></v-progress-circular>
                </v-btn>

                <v-btn
                  @click.native.stop
                  @click="editCampaignSummary=true"
                  color="primary"
                  dark
                  v-if="!editCampaignSummary && showRequiredActions()"
                >
                  <v-icon color="white" small title="Edit Campaign Summary">edit</v-icon>
                </v-btn>
            </v-app-bar>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card
            class="mx-auto"
            outlined
            color="#000000"
            >
              <v-card-text>
                <div :key="index" v-for="(angle, index) in campaign.angles">
                  <v-layout wrap v-if="angle.context || editCampaignSummary">
                    <v-flex xs12 class="flex-one">
                      <div class="form-group">
                        <div class="title">
                          Campaign Context
                        </div>
                        <v-textarea
                          class="report-summary-editor"
                          solo
                          v-model="angle.context"
                          v-if="editCampaignSummary"
                        ></v-textarea>
                        <p class="description" v-else>{{angle.context}}</p>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-layout wrap class="pb-5" :key="index" v-for="(format, index) in angle.formats">
                    <v-flex xs6 md6 class="flex-one" v-if="format.required_action || editCampaignSummary">
                      <div class="form-group">
                        <div class="title">Required action</div>
                        <v-textarea
                          class="report-summary-editor"
                          solo
                          v-model="format.required_action"
                          v-if="editCampaignSummary"
                        ></v-textarea>
                        <p class="description" v-else>{{format.required_action}}</p>
                      </div>
                    </v-flex>
                    <v-flex xs6 md6 class="flex-one">
                      <div class="form-group">
                        <div class="title">Image/Video Pointers</div>
                        <v-textarea
                          class="report-summary-editor"
                          solo
                          v-model="format.image_angle"
                          v-if="editCampaignSummary"
                        ></v-textarea>
                        <p class="description" v-else>{{format.image_angle}}</p>
                      </div>
                    </v-flex>
                    <v-flex xs6 md6 class="flex-one">
                      <div class="form-group">
                        <div class="title">Content Pointers</div>
                        <v-textarea
                          class="report-summary-editor"
                          solo
                          v-model="format.content_angle"
                          v-if="editCampaignSummary"
                        ></v-textarea>
                        <p class="description" v-else>{{format.content_angle}}</p>
                      </div>
                    </v-flex>
                    <v-flex xs12 md12 class="bottomLine"></v-flex>
                  </v-layout>
                  </div>
                <v-layout wrap>
                  <v-flex xs12 md12 class="flex-one">
                    <div class="form-group">
                      <div class="title">Campaign Period</div>
                      <v-layout class="pa-0" wrap v-if="editCampaignSummary">
                        <v-flex xs12 md2>
                          <v-menu
                            ref="monthPicker"
                            v-model="startCal"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="campaign.startDate"
                                append-icon="event"
                                readonly
                                solo
                                v-on="on"
                                style="width:290px;float:left;padding-right:10px;"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              type="month"
                              v-model="campaign.startDate"
                              @input="startCal = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-flex>
                        <v-flex xs12 md1 style="max-width: 20px;padding: 10px 2px 10px;">
                          <span style="color:white;">-</span>
                        </v-flex>
                        <v-flex xs12 md2>
                          <v-menu
                            ref="monthPicker"
                            v-model="endCal"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                            min-width="290px"
                          >
                            <template v-slot:activator="{ on }">
                              <v-text-field
                                v-model="campaign.endDate"
                                append-icon="event"
                                readonly
                                solo
                                v-on="on"
                                style="width:290px;float:left;"
                              ></v-text-field>
                            </template>
                            <v-date-picker
                              type="month"
                              v-model="campaign.endDate"
                              @input="endCal = false"
                            ></v-date-picker>
                          </v-menu>
                        </v-flex>
                      </v-layout>
                      <p class="description" v-else>{{startDate}} - {{endDate}}</p>
                    </div>
                  </v-flex>
                  <v-flex xs12 md12 class="flex-one" v-if="(campaign.lineUp && campaign.lineUp.length>0) || editCampaignSummary">
                    <div class="form-group">
                      <div class="title">Creator Line Up</div>
                      <v-layout class="p-0" wrap v-if="showRequiredActions() && editCampaignSummary">
                        <v-flex xs10 md3>
                          <v-file-input
                            accept="image/png, image/jpeg, image/bmp"
                            label="Select Pictures"
                            prepend-icon=""
                            v-model="files"
                            multiple
                          ></v-file-input>
                        </v-flex>
                      </v-layout>
                      <image-swiper :images="campaign.lineUp" :isShowDelete="showRequiredActions() && editCampaignSummary" @delete="deleteImage"/>
                    </div>
                  </v-flex>
                  <v-flex xs12 md12 class="flex-one" v-if="campaign.optionalRemarks || editCampaignSummary">
                    <div class="form-group">
                      <div class="title">Remarks</div>
                      <v-textarea
                        class="report-summary-editor"
                        solo
                        v-model="campaign.optionalRemarks"
                        v-if="editCampaignSummary"
                      ></v-textarea>
                      <p class="description" v-else>{{campaign.optionalRemarks}}</p>
                    </div>
                  </v-flex>
                  <v-flex xs12 md12 class="flex-one" v-if="campaign.segment">
                    <div class="form-group">
                      <div class="title">Creator Strategy</div>
                      <div>
                        <draggable v-model="campaign.segment" style="width:100%;" class="row no-gutters flex-wrap flex-row fill-height" @update="handleDragDropUpdate(campaign.segment)" v-if="showRequiredActions()">
                          <v-chip
                            v-for="(item, index) in campaign.segment"
                            :key="index"
                            class="mr-2"
                          >
                            {{item}}
                          </v-chip>
                        </draggable>
                        <v-chip
                            v-for="(item, index) in campaign.segment"
                            :key="index"
                            class="mr-2"
                            v-else
                          >
                            {{item}}
                          </v-chip>
                      </div>
                    </div>
                  </v-flex>
                </v-layout>
                </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel expand v-show="isInternalView">
          <v-expansion-panel-header>
            <v-app-bar
                dark
                color="#212121"
                >
                <v-toolbar-title style="text-align:center;">
                  AI Analysis Summary
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn
                  @click.native.stop
                  @click="cancelEdit('ai')"
                  v-if="editAIAnalysis"
                  class="mr-1 secondary--text surface"
                >
                  Cancel
                </v-btn>

                <v-btn
                  @click.native.stop
                  @click="generateAISummary(false)"
                  :loading="generatingSummary"
                  color="primary"
                  text
                  class="mr-1"
                  v-if="editAIAnalysis"
                  title="Generate with AI"
                >
                  <i class="fas fa-magic mr-2"></i> Generate with AI
                </v-btn>

                <v-btn
                  @click.native.stop
                  @click="saveEdit"
                  color="primary"
                  class="secondary--text"
                  v-if="editAIAnalysis && !uploadSubmitting"
                >
                  <v-icon>mdi-done</v-icon> Save
                </v-btn>
                <v-btn
                  @click.native.stop
                  color="warning"
                  dark
                  v-if="editAIAnalysis && uploadSubmitting"
                  :disabled="true"
                >
                  <v-progress-circular indeterminate :size="20"></v-progress-circular>
                </v-btn>

                <v-btn
                  @click.native.stop
                  @click="editAIAnalysis=true"
                  color="primary"
                  dark
                  v-if="!editAIAnalysis && showRequiredActions()"
                >
                  <v-icon color="white" small title="Edit AI Analysis Summary">edit</v-icon>
                </v-btn>
            </v-app-bar>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card
            class="mx-auto"
            outlined
            color="#000000"
            >
              <v-card-text>
                <v-layout wrap v-if="campaign.AISummary || editAIAnalysis || campaign.AISummary === ''">
                  <v-flex xs12 class="flex-one">
                    <div class="form-group">
                      <div class="title">AI-Powered Analysis</div>
                      <v-textarea
                        class="report-summary-editor"
                        solo
                        auto-grow
                        rows="8"
                        v-model="campaign.AISummary"
                        v-if="editAIAnalysis"
                      ></v-textarea>
                      <p class="description" v-else v-html="renderRemark(campaign.AISummary)"></p>
                    </div>
                  </v-flex>
                </v-layout>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
        <v-expansion-panel expand v-show="isInternalView">
          <v-expansion-panel-header>
            <v-app-bar
                dark
                color="#212121"
                >
                <v-toolbar-title style="text-align:center;">
                  AI Notable Comments
                </v-toolbar-title>
                <v-btn
                    icon
                    small
                    @click.native.stop
                    @click="fetchAINotableComments"
                    :loading="aiCommentsLoading"
                    class="ml-2 mt-1"
                    title="Generate with AI"
                >
                    <i class="fas fa-magic"></i>
                </v-btn>
                <v-spacer></v-spacer>
            </v-app-bar>
          </v-expansion-panel-header>
          <v-expansion-panel-content>
            <v-card
              class="mx-auto"
              outlined
              color="#000000"
              >
              <v-card-text>
                <div class="form-group">
                  <v-data-table
                      v-if="campaign.commentAnalysisResult && campaign.commentAnalysisResult.notableComments && campaign.commentAnalysisResult.notableComments.length > 0"
                      :headers="aiHeaders"
                      :items="campaign.commentAnalysisResult.notableComments"
                      :items-per-page="5"
                      class="elevation-1"
                      :loading="aiCommentsLoading"
                      loading-text="Analyzing comments..."
                      hide-default-footer
                  >
                      <template v-slot:item.comment="{ item }">
                          <p>{{ item.comment ? item.comment.comment : 'N/A' }}</p>
                      </template>

                      <template v-slot:item.relevance="{ item }">
                          <v-chip :color="item.relevance === 'RELEVANT' ? 'success' : 'error'" small>
                              {{ item.relevance }}
                          </v-chip>
                      </template>

                      <template v-slot:item.reason="{ item }">
                          <p>{{ item.reason }}</p>
                      </template>

                      <template v-slot:item.checkbox="{ item }">
                          <v-checkbox v-model="item.checked" @change="updateNotableCheckFromTable(item, $event)" hide-details class="mt-0 pt-0"></v-checkbox>
                      </template>
                      
                      <template v-slot:no-data>
                          No notable comments found in the latest analysis.
                      </template>
                  </v-data-table>
                </div>
              </v-card-text>
            </v-card>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-container>
  </div>
</template>
<script>
/* eslint-disable */
import moment from 'moment';
import ImageSwiper from '../scoped/custom/ImageSwiper'
import campaignAPIs from '../views/Campaign/campaignAPIs'
import { buildAnalysisContext } from './kobe/buildReportHtml'
import draggable from 'vuedraggable'
import utils from '../../utils';
import config from '@/config';
export default {
  name: 'rpt_campaign_summary',
  components: {
    ImageSwiper,
    draggable
  },
  // respData: raw report payload (internal view only) — feeds performance data
  // into the AI analysis so it matches the client-facing Kobe report
  props: ['campaign', 'isInternalView', 'respData'],
  data () {
    return {
      panel: [0],
      oldData: {},
      startCal: false,
      endCal: false,
      MONTH_FORMAT: 'MMM YYYY',
      files: [],
      uploadSubmitting: false,
      // Separate edit flags for each section
      editCampaignSummary: false,
      editAIAnalysis: false,
      aiCommentsLoading: false,
      generatingSummary: false,
      aiHeaders: [
        // Note: The 'value' uses the nested structure of the API response: item.comment.comment
        { text: 'Comment', value: 'comment', sortable: false, width: '40%' },
        { text: 'Relevancy', value: 'relevance', sortable: true, width: '15%' },
        { text: 'Reason', value: 'reason', sortable: false, width: '35%' },
        { text: 'HTML Report', value: 'checkbox', sortable: false, width: '10%' } // Mapped column
      ]
    }
  },
  computed: {
    startDate: function() {
      return this.campaign.startDate ? moment(this.campaign.startDate).format(this.MONTH_FORMAT) : '-'
    },
    endDate: function() {
      return this.campaign.endDate ? moment(this.campaign.endDate).format(this.MONTH_FORMAT) : '-'
    },
    enableUpload: function() {
      return this.files.length > 0
    },
    currentUserRole: function() {
      return Number(this.$store.state.user.role);
    }
  },
  created() {
    this.setOldData()
  },
  methods: {
    safeClone(value, fallback = null) {
      if (value === undefined || value === null || value === 'undefined') return fallback
      return JSON.parse(JSON.stringify(value))
    },
    // Nyein - hide seperate file upload section
    // uploadFiles() {
    // 	if (this.files.length > 0) {
    // 		this.uploadSubmitting = true
    // 		let formData = new FormData();
    // 		for (let val of this.files) {
    // 			formData.append('images', val);
    // 		}
    // 		// Submit request to upload file
    // 		campaignAPIs
    // 			.createLineUp(this.campaign.id, formData)
    // 			.then(response => {
    // 				if (response) {
    // 					this.campaign.lineUp = response
    // 				}
    // 				this.files = []
    // 				// Update submitting status
    // 				this.uploadSubmitting = false;
    // 				this.$swal({
    // 					text: 'Successfully Uploaded!',
    // 					type: 'success'
    // 				});
    // 			})
    // 		.catch(error => {
    // 				// Update submitting status
    // 				this.uploadSubmitting = false;
    // 				// Request failed.
    // 				console.log('error', error);
    // 				this.$swal({
    // 					text: error,
    // 					type: 'error'
    // 				});
    // 			});
    // 	}
    // },
    rollbackLineup(lineUp) {
      lineUp = lineUp.map(l => utils.func.cutStringAfterLast(l, '/'))
      return lineUp
    },
    saveEdit() {
      // Collect data from both editable sections
      let data = Object.assign({}, {
        angles: this.campaign.angles,
        startDate: this.campaign.startDate,
        endDate: this.campaign.endDate,
        optionalRemarks: this.campaign.optionalRemarks,
        // ADDED: Include new AI Summary field
        AISummary: this.campaign.AISummary 
      })
      let formData = new FormData();
      formData.append('data', JSON.stringify(data));
      if (this.files.length > 0) {
        formData.append('isImage', true);
        for (let val of this.files) {
          formData.append('images', val);
        }
      }
      this.uploadSubmitting = true
      // Submit request to upload file
      campaignAPIs
        .updateCampaignSummary(this.campaign.id, formData)
        .then(response => {
          // Reset both edit flags on successful save
          this.editCampaignSummary = false
          this.editAIAnalysis = false

          if (this.files.length > 0) {
            this.campaign.lineUp = response.lineUp
            this.files = []
          }
          this.setOldData()
          this.uploadSubmitting = false
        })
      .catch(error => {
        // Request failed.
        console.log('error', error);
        this.$swal({
          text: error,
          type: 'error'
        });
      });
    },
    deleteImage(deleteIndex) {
      this.campaign.lineUp.splice(deleteIndex, 1)
      let lineUpData = this.rollbackLineup(this.campaign.lineUp)
      let formData = new FormData();
      formData.append('images', JSON.stringify(lineUpData));
      // Submit request to upload file
      campaignAPIs
        .updateLineUp(this.campaign.id, formData)
        .then(response => {
          console.log('successfully deleted!')
        })
      .catch(error => {
        // Request failed.
        console.log('error', error);
        this.$swal({
          text: error,
          type: 'error'
        });
      });
    },
    setOldData() {
      const campaign = this.campaign || {}
      // Store original values for rollback
      this.oldData.angles = this.safeClone(campaign.angles, [])
      this.oldData.startDate = this.safeClone(campaign.startDate, '')
      this.oldData.endDate = this.safeClone(campaign.endDate, '')
      this.oldData.optionalRemarks = this.safeClone(campaign.optionalRemarks, '')
      // ADDED: Store original AI Summary
      this.oldData.AISummary = this.safeClone(campaign.AISummary, '')
    },
    cancelEdit(section) {
      // Rollback values based on the section being cancelled
      if (section === 'summary') {
        this.editCampaignSummary = false
        this.campaign.angles = this.safeClone(this.oldData.angles, [])
        this.campaign.startDate = this.safeClone(this.oldData.startDate, '')
        this.campaign.endDate = this.safeClone(this.oldData.endDate, '')
        this.campaign.optionalRemarks = this.safeClone(this.oldData.optionalRemarks, '')
      } else if (section === 'ai') {
        this.editAIAnalysis = false
        // Rollback AI Summary only
        this.campaign.AISummary = this.safeClone(this.oldData.AISummary, '')
      }
    },
    handleDragDropUpdate(segment) {
      let formData = new FormData();
      formData.append('segment', JSON.stringify(segment));
      campaignAPIs
        .updateSegment(this.campaign.id, formData)
        .then(response => {
          console.log('successfully updated!')
        })
      .catch(error => {
        // Request failed.
        console.log('error', error);
        this.$swal({
          text: error,
          type: 'error'
        });
      });
    },
    showRequiredActions: function() {
      if (!this.$store.state.token || this.$store.state.token === 'null' || !this.$store.state.user) {
        return false
      } else {
        return config.userRoles.CLIENT !== this.currentUserRole;
      }
    },
    // Generate the AI-powered campaign analysis (Claude via campaign_service).
    // autoSave=true  -> the section header's quick magic button: generate and
    //                   persist immediately.
    // autoSave=false -> the magic button shown in edit mode (next to Save):
    //                   only fill the textarea so the user can edit first.
    generateAISummary(autoSave = true) {
      // 1. Loop through all campaign angles and concatenate the context strings
      let context = '';
      if (this.campaign.angles && this.campaign.angles.length > 0) {
        context = this.campaign.angles
          .map(angle => angle.context)
          .filter(c => c && c.trim() !== '')
          .join('\n\n---\n\n'); // Concatenate contexts with a clear separator
      }

      // 2. Add the campaign PERFORMANCE context (same data the Kobe HTML
      // report analyses) so the summary is grounded in real numbers.
      let performance = null;
      try {
        const raw = this.respData && (this.respData.data || this.respData);
        if (raw && raw.posts) {
          performance = buildAnalysisContext(raw);
        }
      } catch (e) {
        console.warn('performance context unavailable', e && e.message);
      }

      if (!context && !performance) {
        this.$swal({
          text: 'Campaign Context (or report data) is required to generate AI Analysis.',
          type: 'warning'
        });
        return;
      }

      const combined = performance
        ? JSON.stringify({ campaignBrief: context || undefined, performance })
        : context;
      const data = { campaignContext: combined };

      this.generatingSummary = true; // drives the magic button's spinner
      if (autoSave) this.uploadSubmitting = true;
      this.$emit('loading-status', true);

      // Call the API using the function added to campaignAPIs.js
      campaignAPIs.getCampaignAISummary(data)
        .then(response => {
          // $set so the bound textarea updates even if AISummary was undefined
          this.$set(this.campaign, 'AISummary', response.analysis);
          if (autoSave) {
            // persist immediately (quick generate from the section header)
            this.saveEdit();
          } else {
            // edit-mode draft: keep editing, let the user review and Save
            this.uploadSubmitting = false;
          }
          this.$emit('loading-status', false);
        })
        .catch(error => {
          this.uploadSubmitting = false;
          this.$emit('loading-status', false);
          console.error('AI Summary generation error:', error);
          this.$swal({
            text: 'Failed to generate AI Analysis.',
            type: 'error'
          });
        })
        .finally(() => {
          this.generatingSummary = false;
        });
    },
    renderRemark(remark) {
      if (remark !== undefined && remark !== null) {
        return remark.replace(/\n/g, '<br>');
      }
      return '-'
    },
    /**
     * Calls the backend API to trigger the AI analysis and update the campaign record.
     */
    async fetchAINotableComments() {
      if (!this.campaign || !this.campaign.id) {
        this.$swal({ title: 'Error', text: 'Campaign ID is missing.', type: 'error' });
        return;
      }

      const payload = {
        campaignID: this.campaign.id,
      };

      this.aiCommentsLoading = true;
      // Use parent's loading indicator if available, assuming $emit('loading-status') is the correct interface
      this.$emit('loading-status', true); 

      try {
        const response = await campaignAPIs.getCampaignNotableComments(payload);
        
        // Success: The API updates the campaign record.
        // We trigger the parent component to re-fetch the campaign data and update this prop.
        this.$emit('saved'); 

        this.$swal({
            title: 'AI Analysis Complete',
            text: response.message || 'Notable comments successfully analyzed and saved.',
            type: 'success'
        });

      } catch (error) {
        console.error('AI Notable Comments generation error:', error);
        // Handle axios errors structure or generic error
        const errorMessage = (error.response && error.response.data && error.response.data.error) 
                             ? error.response.data.error 
                             : (error.message || 'Failed to retrieve AI analysis.');
        this.$swal({
          text: errorMessage,
          type: 'error'
        });
      } finally {
        this.aiCommentsLoading = false;
        this.$emit('loading-status', false);
      }
    },
    /**
     * Updates the 'checked' status of a notable comment and saves it to the campaign.
     * @param {Object} comment The notable comment object.
     * @param {Boolean} isChecked The new checked state (true/false).
    */
    async updateNotableCheckFromTable(comment, isChecked)  {
      comment.checked = isChecked; // Set the comment's checked state to the new value

      // Construct the data payload for the API
      // Since 'campaign.commentAnalysisResult.notableComments' should already be reactive,
      // we can use it directly as the updated array of notable comments.
      
      let data = [{
        id: this.campaign.id,
        commentAnalysisResult: this.campaign.commentAnalysisResult
      }]

      try {
        // Submit request to save archived campaign data
        await this.$store.dispatch('campaign/updateCampaignByIds', data);
      } catch (error) {
          // Rollback the change in case of an error
          comment.checked = !isChecked; 
          console.error('Error updating notable comment status:', error);
      }
    }
  }
}
</script>
<style lang="css">
  .summary-section .flex-one {
    padding: 0 5px 20px;
  }
  .summary-section .bottomLine {
    border-bottom: 1px solid #393939;
  }
  .summary-section .v-expansion-panel-header {
    padding: 0 15px;
  }
  .summary-section .v-expansion-panel-content {
    background-color: black;
    border: 1px solid rgb(33, 33, 33);
  }
  /* .summary-section .v-expansion-panel-content__wrap {
    padding: 0!important;
  } */
  .summary-section .v-app-bar {
    box-shadow: none!important;
    background-color: #1e1e1e!important;
  }
  .summary-section .title {
    font-size: 20px;
    color: rgb(255, 183, 77);
    padding-bottom: 5px;
  }
  .summary-section .description {
    font-size: 16px;
    color: #fff
  }
  /* Edit-mode inputs were rendering dark-on-dark (invisible when focused):
     Vuetify's `solo` textarea bakes dark text and `dark` doesn't override it.
     Force a dark slot + white text; -webkit-text-fill-color is required
     because WebKit paints that over `color`. */
  .summary-section .v-text-field--solo .v-input__slot {
    background: #1e1e1e !important;
  }
  .summary-section .v-input textarea,
  .summary-section .v-input input {
    color: #fff !important;
    -webkit-text-fill-color: #fff !important;
    caret-color: #fff !important;
  }
  .summary-section .v-input textarea::placeholder,
  .summary-section .v-input input::placeholder {
    color: #8a8a8a !important;
    -webkit-text-fill-color: #8a8a8a !important;
  }
  .summary-section .mr-2 {
    margin-right: 10px;
  }
  .summary-section .internal-view-container {
    padding-left: 0;
    padding-right: 0;
    width: 100%;
    max-width: 100%;
  }
</style>



// WEBPACK FOOTER //
// CampaignSummary.vue?519582be